import { validateTargetingForm, } from './patch-builder.js';
const diff = (a, b) => ({
    added: b.filter((x) => !a.includes(x)),
    removed: a.filter((x) => !b.includes(x)),
});
const same = (a, b) => {
    const d = diff(a, b);
    return d.added.length === 0 && d.removed.length === 0;
};
const join = (xs, empty = 'нет') => (xs.length === 0 ? empty : xs.join(', '));
const GENDER = { 0: 'Все', 1: 'Мужчины', 2: 'Женщины' };
const ageText = (a) => a.min === null || a.max === null ? '—' : `${a.min}–${a.max}`;
/** Что изменилось в форме — по полям, с добавленным и убранным; ошибки формы привязаны к строкам. */
export function summarizeTargeting(initial, form, names, opts = {}) {
    const problems = validateTargetingForm(form, opts);
    const err = (f) => problems.find((p) => p.field === f)?.message ?? null;
    const rows = [];
    const row = (r) => rows.push({ added: [], removed: [], ...r });
    if (opts.geoEditable !== false) {
        const g0 = initial.geo.mode === 'COUNTRIES' ? initial.geo.countries : [];
        const g1 = form.geo.mode === 'COUNTRIES' ? form.geo.countries : [];
        if (initial.geo.mode !== form.geo.mode || !same(g0, g1)) {
            const d = diff(g0, g1);
            row({
                key: 'geo',
                label: 'Страны',
                before: initial.geo.mode === 'WORLDWIDE' ? 'Весь мир' : join(g0.map(names.country)),
                after: form.geo.mode === 'WORLDWIDE' ? 'Весь мир' : join(g1.map(names.country)),
                added: d.added.map(names.country),
                removed: d.removed.map(names.country),
                error: err('geo'),
            });
        }
        if (!same(initial.excludedCountries, form.excludedCountries)) {
            const d = diff(initial.excludedCountries, form.excludedCountries);
            row({
                key: 'excluded',
                label: 'Исключить страны',
                before: join(initial.excludedCountries.map(names.country)),
                after: join(form.excludedCountries.map(names.country)),
                added: d.added.map(names.country),
                removed: d.removed.map(names.country),
                error: err('excluded'),
            });
        }
    }
    if (initial.age.min !== form.age.min || initial.age.max !== form.age.max) {
        row({
            key: 'age',
            label: 'Возраст',
            before: ageText(initial.age),
            after: ageText(form.age),
            error: err('age'),
        });
    }
    if (initial.gender !== form.gender) {
        row({
            key: 'gender',
            label: 'Пол',
            before: GENDER[initial.gender],
            after: GENDER[form.gender],
            error: null,
        });
    }
    const i0 = initial.interests.map((i) => i.name || i.id);
    const i1 = form.interests.map((i) => i.name || i.id);
    if (!same(initial.interests.map((i) => i.id), form.interests.map((i) => i.id))) {
        const d = diff(i0, i1);
        row({
            key: 'interests',
            label: 'Интересы',
            before: join(i0),
            after: join(i1),
            added: d.added,
            removed: d.removed,
            error: err('interests'),
        });
    }
    for (const [key, label, a, b] of [
        ['custom', 'Аудитории: включить', initial.customAudienceIds, form.customAudienceIds],
        ['excludedAud', 'Аудитории: исключить', initial.excludedAudienceIds, form.excludedAudienceIds],
    ]) {
        if (!same(a, b)) {
            const d = diff(a, b);
            row({
                key,
                label,
                before: join(a.map(names.audience)),
                after: join(b.map(names.audience)),
                added: d.added.map(names.audience),
                removed: d.removed.map(names.audience),
                error: err('audiences'),
            });
        }
    }
    if (initial.advantageAudience !== form.advantageAudience || opts.advantageKnown === false) {
        const chosen = opts.advantageKnown !== false || opts.advantageChosen === true;
        row({
            key: 'advantage',
            label: 'Advantage+ аудитория',
            before: opts.advantageKnown === false
                ? 'не задана'
                : initial.advantageAudience
                    ? 'Включена'
                    : 'Выключена',
            after: chosen ? (form.advantageAudience ? 'Включена' : 'Выключена') : 'не выбрано',
            error: err('advantage'),
        });
    }
    return { rows, problems };
}
//# sourceMappingURL=summary.js.map